const MixedColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 412px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 110 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

export { MixedColumn };
